<!-- Status Configuration starts -->
<div class="container" id="edit-service">
  <div class="row">
    <div class="col-12 mt-3">
      <form #myForm="ngForm">
        <div class="card mb15">
          <div class="card-header">
            <h4 class="card-title" translate>lblMapNextAvailableStatus</h4>
          </div>
          <div class="card-content">
            <div class="card-body">
              <div class="row">
                <div class="col-3 af-form-group">
                  <label for="template-edit-Page" translate>lblCurrentWOStatus</label>
                  <div class="lbl-info mh-35 mb-2" *ngFor="let status of statusList; let i=index">
                    <ng-select [(ngModel)]="status.id" [ngModelOptions]="{standalone: true}" [disabled]="true">
                      <ng-option *ngFor="let status of statusList" [value]="status.id">
                        {{status.name}}
                      </ng-option>
                    </ng-select>
                  </div>
                </div>
                <div class="col-2 af-form-group">
                  <label for="template-edit-Page" translate>lblAOstatus</label>
                  <div class="lbl-info">
                    <div class="mh-35 mb-2" *ngFor="let status of statusList; let i=index;">
                      <ng-select name="customer-statusList{{i}}" 
                        [disabled]="!userRoleRightsDetails.canEdit" placeholder="{{ 'lblStatus' | translate }}"
                        [(ngModel)]="mapAOData[i].selectedId">
                        <ng-option *ngFor="let list of AOStatusList" [value]="list.id">
                          {{list.name}}</ng-option>
                      </ng-select>
                    </div>
                  </div>
                </div>
                <div class="col-5 af-form-group">
                  <label for="template-edit-Page" translate>lblPossiblenextWOstatus</label>
                  <div class="lbl-info">
                    <div class="mh-35 mb-2" *ngFor="let status of statusList; let i=index;">
                      <ng-select [multiple]="true" name="customer-status{{i}}"
                        [disabled]="!userRoleRightsDetails.canEdit" placeholder="{{ 'lblStatus' | translate }}"
                        [(ngModel)]="mapData[i].selectedIds">
                        <ng-option *ngFor="let status of statusList" [value]="status.id">
                          {{status.name}}</ng-option>
                      </ng-select>
                    </div>
                  </div>
                </div>

                <div class="col-auto af-form-group">
                  <label for="template-edit-Page" translate>lblEditable</label>
                  <div class="lbl-info">
                    <div class="mh-35 mb-2" *ngFor="let status of statusList; let i=index;">
                      <div class="custom-control custom-switch mt-2">
                        <input type="checkbox" class="custom-control-input" id="isActive{{i}}" name="isActive{{i}}"
                          [(ngModel)]="mapEdit[i].edit">
                        <label class="custom-control-label" for="isActive{{i}}" translate>lblEdit</label>
                      </div>
                    </div>
                  </div>
                </div>

                <div class="col-auto af-form-group">
                  <label for="template-edit-Page" translate>lblDeletable</label>
                  <div class="lbl-info">
                    <div class="mh-35 mb-2" *ngFor="let status of statusList; let i=index;">
                      <div class="custom-control custom-switch mt-2">
                        <input type="checkbox" class="custom-control-input" id="isDelete{{i}}" name="isDelete{{i}}"
                          [(ngModel)]="mapDelete[i].delete">
                        <label class="custom-control-label" for="isDelete{{i}}" translate>lblDelete</label>
                      </div>
                    </div>
                  </div>
                </div>

              </div>
            </div>
          </div>
        </div>
      </form>
      <div class="row">
        <ng-container *ngIf="userRoleRightsDetails.canEdit">
          <div class="col-12 d-flex flex-sm-row flex-column justify-content-end mb15">
            <button type="submit" aria-label="Center Align" class="btn btn-primary" (click)="saveStatus()" translate><em class="far fa-save font16 align-top mr-2"></em>lblSaveChanges</button>
          </div>
        </ng-container>
      </div>
    </div>
  </div>
</div>
<!-- Status Configuration ends -->